import { useTranslation } from 'react-i18next';

import MainTitle from '../common/MainTitle';
import Culture from '../../assets/images/careers/culture-and-environment.jpeg';
import CultureWebp from '../../assets/images/careers/culture-and-environment.webp';

/**
 *
 * @param {{ title1: string, title2: string, description: string, isReversed?: boolean }} props
 * @returns
 */

export default function CultureEnvironment({title1, title2, description, isReversed }) {
  const { t } = useTranslation(['CareersPage']);

  return (
    <div className="culture">
      <section className={`culture-section container ${isReversed ? 'reversed' : ''}`}>
        <div className="culture-section__header mobile">
          <MainTitle type="dark" className="text--2xl">
            <span>{t(title1)}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {t(title2)}
            </span>
          </MainTitle>
        </div>

        <div className="culture-section__content">
          <div className="culture-section__header desktop">
            <MainTitle type="dark" className="text--2xl">
              <span>{t(title1)}</span>
              <span className="decorated-line decorated-line--dark decorated-line--left">
                {t(title2)}
              </span>
            </MainTitle>
          </div>
          <p>{t(description)}</p>
        </div>

        <div className="culture-section__media">
          <picture>
            <source srcSet={CultureWebp} type="image/webp" />
            <img src={Culture} alt="Teachers having a meeting" />
          </picture>
        </div>
      </section>
    </div>
  );
}
